import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2791d7d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "control" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "5",
  y: "16",
  width: "14",
  height: "2"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "5",
  y: "11",
  width: "14",
  height: "2"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "5",
  y: "6",
  width: "14",
  height: "2"
}, null, -1))
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { class: "navSwitch" }
const _hoisted_7 = { class: "main" }
const _hoisted_8 = { class: "main-page-container" }
const _hoisted_9 = { class: "foot-container" }

import { RootState } from '@/store';
import P404 from '@/views/components/P404.vue';
import { ref, computed, withDefaults, watch } from 'vue';
import { useStore } from 'vuex';
import Foot from './Foot.vue';
import Navigators from './Navigators.vue';
import SwitchMode from "@/views/components/SwitchMode.vue";
import SwitchLang from "@/views/components/SwitchLang.vue";
import { useRoute } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  props: {
    leftWidth: { default: 0 },
    leftFull: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { leftWidth: number, leftFull: boolean }

const route = useRoute();

const store = useStore()
const rootState = computed<RootState>(() => store.state)

const active = ref(false)
watch(
    () => route.fullPath,
    async () => {
        active.value = false
    }
);
const style = computed(() => {
    return {
        paddingLeft: props.leftWidth + 80 + 'px'
    }
})
const leftStyle = computed(() => {
    return {
        width: props.leftWidth + 'px',
        padding: props.leftFull ? 0 : '10px'
    }
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["desktop", { dark: _unref(rootState).darkMode }]),
    style: _normalizeStyle(_unref(style))
  }, [
    (!_unref(rootState).videoFullScreen)
      ? (_openBlock(), _createBlock(Navigators, { key: 0 }))
      : _createCommentVNode("", true),
    (!_unref(rootState).videoFullScreen && __props.leftWidth)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["menus", active.value ? 'active' : null]),
          style: _normalizeStyle(_unref(leftStyle))
        }, [
          _createElementVNode("div", _hoisted_1, [
            (_openBlock(), _createElementBlock("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              viewBox: "0 0 24 24",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (active.value = !active.value))
            }, _hoisted_5))
          ]),
          _renderSlot(_ctx.$slots, "left-side"),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(SwitchLang),
            _createVNode(SwitchMode)
          ])
        ], 6))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      (!_unref(rootState).videoFullScreen)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "top-container",
            style: _normalizeStyle(_unref(style))
          }, [
            _renderSlot(_ctx.$slots, "top-bar")
          ], 4))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createElementVNode("div", _hoisted_8, [
          (_unref(store).state.page404)
            ? (_openBlock(), _createBlock(P404, { key: 0 }))
            : (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", {
          class: _normalizeClass(["page-default", { 'page-media': __props.leftWidth == 220 }])
        }, [
          _createVNode(Foot)
        ], 2)
      ])
    ])
  ], 6))
}
}

})